import { useEffect } from 'react';

const HomeSeo = () => {
  useEffect(() => {
    document.title = '전립상회 PAC KOREA | 전립선 건강 프리미엄 건강기능식품';

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '전립상회 PAC KOREA 공식 홈페이지. 박문수 원장이 설계한 프로엑티브 시리즈 - 전립선 건강기능식품, 오메가3, 릴랙스, 체중관리. 식약처 인증·GMP 공장 생산·HACCP 인증.');
    setMeta('keywords', '전립상회, PAC KOREA, 전립선 건강기능식품, 프로엑티브, 식약처인증');
    setMeta('robots', 'index, follow');

    setMeta('og:title', '전립상회 PAC KOREA | 전립선 건강 프리미엄 건강기능식품', true);
    setMeta('og:description', '박문수 원장이 직접 설계한 프로엑티브 시리즈. 전립선 건강·오메가3·릴랙스·체중관리 건강기능식품. 식약처 인증, GMP 공장 생산.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`, true);
    setMeta('og:locale', 'ko_KR', true);
    setMeta('og:site_name', '전립상회 PAC KOREA', true);
    setMeta('og:image', 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/f709ae3db271d6c0d8bf92ab254501ef.png', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', '전립상회 PAC KOREA | 전립선 건강 프리미엄 건강기능식품');
    setMeta('twitter:description', '박문수 원장이 직접 설계한 프로엑티브 시리즈. 전립선 건강·오메가3·릴랙스·체중관리 건강기능식품.');
    setMeta('twitter:image', 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/f709ae3db271d6c0d8bf92ab254501ef.png');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`);

    let lastmod = document.querySelector('meta[name="last-modified"]') as HTMLMetaElement | null;
    if (!lastmod) {
      lastmod = document.createElement('meta');
      lastmod.setAttribute('name', 'last-modified');
      document.head.appendChild(lastmod);
    }
    lastmod.setAttribute('content', new Date().toISOString().split('T')[0]);
  }, []);

  return null;
};

export default HomeSeo;
